import { render, staticRenderFns } from "./radio-input-item.vue?vue&type=template&id=1cc5990c&scoped=true&"
import script from "./radio-input-item.vue?vue&type=script&lang=js&"
export * from "./radio-input-item.vue?vue&type=script&lang=js&"
import style0 from "./radio-input-item.vue?vue&type=style&index=0&id=1cc5990c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc5990c",
  null
  
)

export default component.exports